import { useSearchParams } from "react-router-dom";
import { Phone, Mail, MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";
import { Reveal } from "@/components/Reveal";
import { IMG, CONTACT } from "@/data/content";

const Quote = () => {
  const [params] = useSearchParams();
  return (
  <main data-testid="quote-page">
    <PageHero
      eyebrow="Get a Quote"
      title="Tell Us What"
      italic="You Need"
      description="Share your requirement and our team will respond with specifications, availability and a quotation tailored to your property."
      image={IMG.towels}
    />

    <section className="py-24 md:py-32">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="bg-ivory border border-navy/10 p-8 md:p-14">
            <div className="flex items-center gap-4 mb-3">
              <span className="h-px w-10 bg-gold/60" />
              <span className="text-[11px] tracking-[0.32em] uppercase text-navy/60">Product Enquiry Form</span>
            </div>
            <h2 className="font-serif text-3xl md:text-4xl font-medium text-navy mb-12">
              Request a Quotation
            </h2>
            <EnquiryForm initialProduct={params.get("product") || ""} />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="grid sm:grid-cols-3 gap-px bg-navy/10 border border-navy/10 mt-10">
            <a href="tel:+917603810376" data-testid="quote-call-option" className="group bg-ivory p-8 flex flex-col gap-3 transition-colors duration-500 hover:bg-navy">
              <Phone size={20} className="text-gold" />
              <span className="text-[11px] tracking-[0.24em] uppercase text-navy/50 group-hover:text-ivory/60">Call Us</span>
              <span className="font-serif text-lg text-navy group-hover:text-ivory">{CONTACT.phonePrimary}</span>
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="quote-email-option" className="group bg-ivory p-8 flex flex-col gap-3 transition-colors duration-500 hover:bg-navy">
              <Mail size={20} className="text-gold" />
              <span className="text-[11px] tracking-[0.24em] uppercase text-navy/50 group-hover:text-ivory/60">Email Us</span>
              <span className="font-serif text-lg text-navy group-hover:text-ivory break-all">{CONTACT.email}</span>
            </a>
            <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="quote-whatsapp-option" className="group bg-ivory p-8 flex flex-col gap-3 transition-colors duration-500 hover:bg-navy">
              <MessageCircle size={20} className="text-gold" />
              <span className="text-[11px] tracking-[0.24em] uppercase text-navy/50 group-hover:text-ivory/60">WhatsApp</span>
              <span className="font-serif text-lg text-navy group-hover:text-ivory">Chat with our team</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  </main>
  );
};

export default Quote;
